import AIProgressNote from "./ai_progress_note";
import AIDischargeSummary from "./ai_discharge_summary";
import AIGenericForm from "./ai_generic_form";

export const AI_DECORATOR_DEF = {
    "AIProgressNote":AIProgressNote,
    "AIDischargeSummary":AIDischargeSummary,
    "AIGenericForm":AIGenericForm
}